import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { Loader, Menu, Dropdown } from 'semantic-ui-react';

import moment from 'moment';
import CampaignsTable from '../../components/campaigns-table';
import DyzioEmptyState from '../../components/dyzio-empty-state';
import { DyzioWarningMessage } from '../../components/dyzio-messages';

import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasLocalStorageClient from '../../hocs/has-localstorage-client';
import hasViewModeManagement from '../../hocs/has-viewmode-management';

const getLastSixMonths = () =>
  _.map(_.range(6), i => {
    const m = moment().subtract(i, 'months');
    return {
      key: m.format('YYYY-MM'),
      value: m.format('YYYY-MM'),
      text: m.format('YYYY - MMMM'),
    };
  });

const monthOptions = getLastSixMonths();


class LaunchMetricsCampaignsList extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };


  render() {
    const { userInfo: { email, name: userName, userId } } = this.props;
    const messageProps = {
      email, userName, userId,
    };

    const {
      isLoading,
      isLoaded,
      isFailed,
      records,
      isLoadingCampaigns,
      isTimeoutError,
      selectedMonth,
    } = this.props;

    const noCampaignPermissions = _.isEmpty(records);
    const isLoadSuccess = isLoaded && !isFailed && !noCampaignPermissions;
    const isLoadEmptyData = isLoaded && !isFailed && noCampaignPermissions;

    return (
      <div>
        <Menu icon>
          <Menu.Menu position="left">
            <Dropdown
              onChange={this.props.onMonthSelect}
              value={selectedMonth}
              options={monthOptions}
              simple
              item
            />
          </Menu.Menu>
        </Menu>
        { isLoading && <Loader active content="Loading campaigns..." /> }
        {
          isTimeoutError && <DyzioWarningMessage
            header="Sorry... Your request timed out!"
            content="Our tech team has been informed and will look into the issue for you."
            reportMessage="Loading campaigns timeout"
            reportMessageArgs={messageProps}
          />
        }
        {
          isLoadEmptyData &&
          <DyzioEmptyState
            isSearchContext={false}
            buttonLabel="Add a campaign"
            helpUrl="https://help.dyzio.co/en/articles/5089448-how-to-create-a-campaign"
            context="CAMPAIGNS"
            onClick={this.toggleAddNewCampaignModalState}
            content={
              <div>
                <p>No results!</p>
                <p>Can not find campaigns for given month </p>
              </div>
            }
          />
        }
        {
          isLoadSuccess &&
            <CampaignsTable
              records={records}
              isLoadingCampaigns={isLoadingCampaigns}
            />
        }
      </div>
    );
  }
}
LaunchMetricsCampaignsList.propTypes = {
  onMonthSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
  isFailed: PropTypes.bool,
  records: PropTypes.array,
  isLoadingCampaigns: PropTypes.bool,
  isTimeoutError: PropTypes.bool,
  selectedMonth: PropTypes.string,
};
LaunchMetricsCampaignsList.defaultProps = {
  isLoading: false,
  isLoaded: false,
  isFailed: false,
  records: [],
  isLoadingCampaigns: false,
  isTimeoutError: false,
  selectedMonth: '',
};


export default compose(
  hasRESTClient,
  hasJSONAPIClient,
  hasUserInfo,
  hasLocalStorageClient,
  hasViewModeManagement,
)(LaunchMetricsCampaignsList);



/** WEBPACK FOOTER **
 ** ./src/containers/launch-metrics-campaign-list/index.js
 **/